module.exports = __webpack_public_path__ + "static/media/kyowa-kirin.3baf9d2e.png";